export default __webpack_public_path__ + "static/media/cp_geo_sc.0ae428ce.svg";